import React, { Component } from "react";
import {
  Table, Icon, Button, Input,
  Switch, Modal, Col, Row, Tooltip, Checkbox
} from "antd";
import axios from "axios";
import Fatrophy from 'react-icons/lib/fa/trophy';
import Facheck from 'react-icons/lib/fa/check';
import "./CotacoesPage.css";
import moment from "moment-timezone";
import CotacoesForm from '../components/CotacoesForm';
import InputForm from "../components/InputForm";
// import { maskNumber, maskDecimal } from '../utils/Masker';
import { getTipoUsuario } from '../utils/LoginManager';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class CotacoesPage extends Component {
  state = {
    cotacoes: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    cotacaoAtiva: true,
    retornada: false,
  };

  // este é invocado quando o camponente termina de carregar
  // after show
  componentDidMount() {
    this.getCotacoes();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getCotacoes)
    }
  }




  getCotacoes = () => {
    this.setState({ carregando: true });

    const { cotacao, produto, pfj, cotacaoAtiva, pagina, limite } = this.state;

    // alert(cotacaoAtiva);

    axios
      .get('/cotacoes', {
        params: {
          page: pagina,
          limite: limite,
          codigoCotacao: cotacao,
          descricaoProduto: produto,
          PFJForn: pfj,
          cotacaoAtiva: cotacaoAtiva,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          cotacoes: data,
          carregando: false,
          mensagemErro: '',
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
          mensagemErro: "Não foi possível obter as cotação."
        });
      });
  };

  onBuscarCotacao = (texto) => {
    this.setState({
      buscaCotacao: texto
    },
      this.getCotacoes);
  };

  onBuscar = event => {
    event.preventDefault();
    this.getCotacoes();
  }

  onEditarClick = cotacao => {
    this.setState({ carregando: true });

    axios.get(`/cotacoes/${cotacao.compras_cot_codigo}/item/${cotacao.compras_ci_item}/seq/${cotacao.compras_ci_seq}/forn/${cotacao.compras_cfi_pfj}`)
      .then(response => {
        const { data } = response;
        data.marca = {
          key: data.compras_cfr_marca,
          label: data.estoq_mar_descricao,
        }
        console.log(data.marca)
        this.setState({
          formVisivel: true,
          cotacaoSelecionada: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.warn(error);
        this.setState({
          carregando: false,
          mensagemErro: 'Não foi possível consultar a cotação selecionada.'
        })
      })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onSalvarClick = (cotacao) => {
    this.setState({
      salvando: true
    })

    console.log(cotacao);

    axios.put(`/cotacoes/${cotacao.compras_cot_codigo}/item/${cotacao.compras_ci_item}/seq/${cotacao.compras_ci_seq}/forn/${cotacao.compras_cfi_pfj}`, cotacao)
      .then(response => {

        console.log(response.data)

        this.getCotacoes();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
      })
      .catch(error => {
        console.warn(error.response);
        console.warn(error);
        this.setState({
          salvando: false
        })
        Modal.error({
          title: 'Erro Inesperado',
          content: 'Não foi possível salvar a cotação.',
          okText: 'OK',
        })
      })
  }

  onDesativaChange = (cotacao, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    console.log('desativar')

    request = axios.delete(`/cotacoes/${cotacao.compras_cot_codigo}/item/${cotacao.compras_ci_item}/seq/${cotacao.compras_ci_seq}/forn/${cotacao.compras_cfi_pfj}/desativa`, cotacao)

    request.then(response => {
      this.getCotacoes();
    }).catch(error => {
      console.warn(error);
      this.setState({
        mensagemErro: "Não foi possível desativar esta tarefa.",
        carregando: false
      })
    })
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onChangeCheck = event => {
    console.log(`checked = ${event.target.checked}`);
    this.setState({
      cotacaoAtiva: event.target.checked
    })
  };

  onTabelaChange = (pagination => {
    console.log(pagination);
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getCotacoes)
  })

  renderStatus = (status, cotacao) => {
    if (cotacao.compras_cfr_ganhou_cotacao === 'S') {
      return (
        <Tooltip placement="top" title='Venceu' size="small">
          <div tooltip="Retornado" style={{ textAlign: 'center' }}>
            <Fatrophy size={20} />
          </div>
        </Tooltip>
      );
    }
    if (cotacao.compras_cfi_flag_situacao === 'A') {
      return (
        <Tooltip placement="top" title='Pendente' size="small">
          <div style={{ textAlign: 'center' }}>
            --
        </div>
        </Tooltip>
      );
    }
    if (cotacao.compras_cfi_flag_situacao === 'R') {
      return (
        <Tooltip placement="top" title='Retornado' size="small">
          <div style={{ textAlign: 'center' }}>
            <Facheck size={20} />
          </div>
        </Tooltip>
      );
    }
  };

  renderData = (data, cotacao) => {
    const dataMoment = moment(data);
    return (
      <span title={dataMoment.format('DD [de] MMMM [de] YYYY [às] HH:mm')}>
        {dataMoment.format('DD/MM/YYYY HH:mm')}
      </span>
    )
  }

  renderAtiva = (retorno, cotacao) => {
    console.log(cotacao);
    let estaInativo = moment(cotacao.compras_cot_data_encerramento).isBefore(moment());
    if (!estaInativo) {
      estaInativo = cotacao.compras_cfi_flag_situacao === "A";
    }  
    return (
      <Switch
        checkedChildren="Sim"
        unCheckedChildren="Não"
        checked={cotacao.compras_cfi_flag_situacao === "R"}
        disabled={estaInativo}
        onChange={ativar => this.onDesativaChange(cotacao, ativar)}
      />
    );
    return retorno ? "Sim" : "Não";
  };

  renderAcoes = (text, cotacao) => {
    return (
      <Tooltip placement="top" title='Retornar'>
        <Icon type={'edit'}
          className="cotacoesPageIconeRetorno"
          onClick={() => this.onEditarClick(cotacao)}
        />
      </Tooltip>
    );
  };

  render() {
    const { cotacoes, carregando, mensagemErro, formVisivel, salvando,
      cotacaoSelecionada, total, pagina, limite,
      cotacao, produto, pfj, cotacaoAtiva } = this.state;

    const isUsuario = getTipoUsuario() === 'usuario'; // BUSCA SE É USUARIO OU PESSOA LOGADA

    return (
      <div>
        <h2 className="tituloPage">Cotações do Fornecedor</h2>
        <hr />
        <br />

        <div className="cotacoesPageFiltro">
          <form onSubmit={this.onBuscar}>
            <Row>
              {isUsuario ? (
                <Col xs={24} sm={4} className="cotacoesPageFiltro-camposBusca">
                  <InputForm
                    label="Fornecedor"
                    id="pfj"
                    ref="pfj"
                    value={pfj}
                    onChange={this.onChange}
                  />
                </Col>
              ) : null}
              <Col xs={24} sm={4} className="cotacoesPageFiltro-camposBusca">
                <InputForm
                  label="Cotação"
                  id="cotacao"
                  ref="cotacao"
                  onChange={this.onChange}
                  value={cotacao}
                />
              </Col>
              <Col xs={24} sm={4} className="cotacoesPageFiltro-camposBusca">
                <InputForm
                  label="Produto"
                  id="produto"
                  ref="produto"
                  value={produto}
                  onChange={this.onChange}
                />
              </Col>

              <Col xs={24} sm={5} className="cotacoesPageFiltro-checkBusca">
                <Checkbox
                  id="cotacaoAtiva"
                  ref="cotacaoAtiva"
                  onChange={this.onChangeCheck}
                  value={cotacaoAtiva}
                  checked={cotacaoAtiva}
                >
                  Somente Cotações Ativas
                </Checkbox>
              </Col>

              <Col xs={24} sm={1} className="cotacoesPageFiltro-botaoBusca">
                <Button
                  htmlType="submit"
                  type="primary"
                >
                  Buscar
                </Button>
              </Col>
            </Row>
          </form>
        </div>

        <CotacoesForm
          visivel={formVisivel}
          onSalvarClick={this.onSalvarClick}
          onCancelarClick={this.onCancelarClick}
          carregando={salvando}
          cotacaoSelecionada={cotacaoSelecionada}
        />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={cotacoes}
          scroll={{ x: 600 }}
          rowKey={cotacao => JSON.stringify(cotacao)}
        >
          <Column
            key="compras_cfi_flag_situacao"
            dataIndex="compras_cfi_flag_situacao"
            title="Status"
            render={this.renderStatus}
            width={60}
            align="center"
          />
          <Column
            key="compras_cot_codigo"
            dataIndex="compras_cot_codigo"
            title="Cotação"
            width={65}
          />
          <Column
            key="compras_cot_data_encerramento"
            dataIndex="compras_cot_data_encerramento"
            title="Expira em"
            render={this.renderData}
            width={85}
            align="center"
          />
          <Column
            key="compras_ci_item"
            dataIndex="compras_ci_item"
            title="Produto"
            width={70}
          />
          <Column
            key="estoq_ie_descricao"
            dataIndex="estoq_ie_descricao"
            title="Descrição do Produto"
            width={350}
          />
          <Column
            title="Retorno"
            key="retorno"
            dataIndex="retorno"
            render={this.renderAtiva}
            width={65}
          />
          <Column
            key="acoes"
            render={this.renderAcoes}
            width={30}
            align="center"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CotacoesPage.js